import { Checkbox, Menu } from 'antd'
import { useTranslation } from 'react-i18next'

import { SourceStage } from '~app/graph/generated/graphql'

/*
 * Component
 */

interface Props {
  setSelectedKeys: (v: SourceStage[]) => void
  confirm: any
  clearFilters: any
  selectedKeys: SourceStage[]
}

{
  /* 
  styles/comp structure taken from antd's default filter comp:
  https://github.com/ant-design/ant-design/blob/master/components/table/filterDropdown.tsx
*/
}
const StageFilters = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
}: Props) => {
  const { t } = useTranslation()
  const filters = [
    {
      text: t('sources.sourceStages.Requested'),
      value: SourceStage.Requested,
    },
    {
      text: t('sources.sourceStages.Activating'),
      value: SourceStage.Activating,
    },
    {
      text: t('sources.sourceStages.Activated'),
      value: SourceStage.Activated,
    },
    {
      text: t('sources.sourceStages.Renewing'),
      value: SourceStage.Renewing,
    },
    {
      text: t('sources.sourceStages.NoExtension'),
      value: SourceStage.NoExtension,
    },
    {
      text: t('sources.sourceStages.Cancelling'),
      value: SourceStage.Cancelling,
    },
    {
      text: t('sources.sourceStages.Canceled'),
      value: SourceStage.Canceled,
    },
    {
      text: t('sources.sourceStages.Expired'),
      value: SourceStage.Expired,
    },
    {
      text: t('sources.sourceStages.Expiring'),
      value: SourceStage.Expiring,
    },
  ]
  return (
    <>
      <Menu selectable={false} className="ant-dropdown-menu">
        {filters.map(({ text, value }) => (
          <Menu.Item
            className="ant-dropdown-menu-item"
            onClick={() =>
              selectedKeys.includes(value)
                ? setSelectedKeys(selectedKeys.filter(v => v !== value))
                : setSelectedKeys([...selectedKeys, value])
            }
            key={value}
            style={{ height: '32px' }}
          >
            <Checkbox checked={selectedKeys.indexOf(value) >= 0} />
            <span>{text}</span>
          </Menu.Item>
        ))}
      </Menu>
      <div
        className={'ant-table-filter-dropdown-btns'}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <a
          role="button"
          className={'ant-table-filter-dropdown-link confirm'}
          onClick={confirm}
        >
          {t('labels.ok')}
        </a>
        <a
          role="button"
          className={'ant-table-filter-dropdown-link confirm'}
          onClick={() => (
            setSelectedKeys(filters.map(({ value }) => value)), confirm()
          )}
        >
          {t('labels.all')}
        </a>
        <a
          role="button"
          className={'ant-table-filter-dropdown-link clear'}
          onClick={() => (setSelectedKeys([]), clearFilters())}
        >
          {t('labels.reset')}
        </a>
      </div>
    </>
  )
}

export default StageFilters
